var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".descriptions[data-v-6d49aae4]{background:url(" + escape(require("../../../assets/images/metal/titleBG.png")) + ") 0 0 no-repeat;background-size:100% 100%}", ""]);

// exports
